import { render } from "./ShoppingChart.vue?vue&type=template&id=63dc33ff"
import script from "./ShoppingChart.vue?vue&type=script&lang=js"
export * from "./ShoppingChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__